import settings from 'settings'
import { getRequest, postRequest, deleteRequest } from 'features/common/api/requests'
import { ActivityDataExportJobStatus, JobStatusType } from 'features/jobs/types'

const { accountsApiUrl } = settings
const BASE_URL = `${accountsApiUrl}/activity-data-jobs`

export async function createDatasetExportJob({
  categories,
  format,
  startTime,
  endTime
}: {
  categories: string[]
  format: string
  startTime: string
  endTime: string
}): Promise<string> {
  const result = await postRequest(`${BASE_URL}`, { categories, format, startTime, endTime })
  return result.id
}

export async function getActivityDataJobStatus({ jobId }: { jobId: string }): Promise<ActivityDataExportJobStatus> {
  const url = `${BASE_URL}/${jobId}`
  const response: {
    id: string
    status: JobStatusType
    errorMessage?: string
    downloadUrls?: Record<string, string[]>
    downloadUrlsExpirationDate?: string
  } = await getRequest(url)
  return {
    jobId: response.id,
    status: response.status,
    errorMessage: response.errorMessage,
    downloadUrls: response.downloadUrls,
    downloadUrlsExpirationDate: response.downloadUrlsExpirationDate
  }
}

export async function cancelActivityDataJob({ jobId }: { jobId: string }): Promise<{ status: string }> {
  const url = `${BASE_URL}/${jobId}/cancel`
  const jobStatus: { status: string } = await deleteRequest(url)
  return jobStatus
}
